
import React from 'react';
import LogoImage from '../../assets/main/logo-white.png'
import { LoginSignupLayoutProps } from '../../interfaces';

import {
  CardWrapper,
  Header,
  LoginPageContainer,
  Logo,
  FooterLinkContainer,
  LinkText,
} from './styles';


const LoginSignupLayout: React.FC<LoginSignupLayoutProps> = ({ children }) => {

  return (
    <LoginPageContainer>
      <Header>
        <Logo>
          <img src={LogoImage} alt="Logo" />
        </Logo>
      </Header>
      <CardWrapper>
        {children}
        <FooterLinkContainer>
          Looking for an account? <LinkText href="/contact">Contact Our Support</LinkText>
        </FooterLinkContainer>
      </CardWrapper>
    </LoginPageContainer>
  );
};

export default LoginSignupLayout;

